<template>
    <div>
        <div v-if="authUserPermission['scope-of-supply-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--7">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-6">
                                        <h3 class="mb-0">Scope of Supply</h3>
                                    </div>
                                    <div class="col-6">
                                        <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_sos')" v-on:keyup="filter"/> 
                                    </div>
                                </div>
                            </div>
                            <div class="card-body" style="height: 400px; max-height: 400px; overflow-y: auto;">
                                <div v-if="!onLoad.sos">
                                    <el-tree ref="sosTree" :data="table.data" :props="table.treeProps" node-key="id" :default-expand-all="false" :expand-on-click-node="false" class="sos-tree" v-if="table.data.length > 0" @node-click="handleSosNodeClick">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <span class="tree-node-left">
                                                <span class="sos-header">{{ data.sos_header }}</span>
                                            </span>
                                            <span class="tree-node-content">
                                                <span class="sos-description">{{ data.sos_description }}</span>
                                            </span>
                                        </span>
                                    </el-tree>

                                    <div class="text-center mt-4" v-else style="height: 200px">
                                        <img src="/assets/smartcat/data_is_empty.png" alt="No Data" width="250px">
                                        <p class="text-muted mt-3">No Scope of Supply data found</p>
                                    </div>
                                </div>

                                <div v-else>
                                    <page-loading />
                                </div>
                            </div>
                            <div class="card-footer pb-0 ">   
                                <span class="float-left">
                                    <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                                </span>                             
                                <span class="float-right">
                                    {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12">
                                        <h3 class="mb-1">KBLI</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body" style="height: 400px; max-height: 400px; overflow-y: auto;">
                                <div v-if="!onLoad.kbli">
                                    <el-tree ref="sosTree" :data="tableKbli.data" :props="tableKbli.treeProps" node-key="id" :default-expand-all="false" :expand-on-click-node="false" class="sos-tree" v-if="tableKbli.data.length > 0">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <span class="tree-node-left">
                                                <span class="sos-header">{{ data.code }}</span>
                                            </span>
                                            <span class="tree-node-content">
                                                <span class="sos-description">{{ data.description }}</span>
                                                <span class="sos-definition" v-if="data.definition">{{ data.definition }}</span>
                                            </span>
                                        </span>
                                    </el-tree>

                                    <div class="text-center mt-4" v-else>
                                        <img src="/assets/smartcat/data_is_empty.png" alt="No Data" width="250px">
                                        <p class="text-muted mt-3">No Relation KBLI data found</p>
                                    </div>
                                </div>

                                <div v-else>
                                    <page-loading />
                                </div>
                            </div>
                            <div class="card-footer">                         
                                <div class="col text-right">
                                    {{ tt('page_info', {size: tableKbli.total, total: tableKbli.total}) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="(message, idx) in errorMessage.data" :key="idx">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>
                        
                        <label class="form-control-label">{{ tt('sos_header') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('sos_header')" :placeholder="tt('sos_header')" v-model="scopeofSupply.sos_header" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('sos_description') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('sos_description')" :placeholder="tt('sos_description')" v-model="scopeofSupply.sos_description" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('material_group') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('material_group')" rules="required">
                            <el-select v-model="scopeofSupply.material_group" multiple placeholder="Select Material Group">
                                <el-option
                                  v-for="item in materialGroup"
                                  :key="item.id"
                                  :label="item.code"
                                  :value="item.code">
                                </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.showTableing || invalid">
                            <span v-if="btnSave.showTableing"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import scopeofSupply from '@/services/dictionary/scopeofSupply.service';
    import materialGroup from '@/services/master/materialGroup.service';

    export default {        
        data() {
            return {   
                currentRow: null,
                onLoad: {
                    sos: true,
                    kbli: true,
                },
                loadTimeout: null,
                btnSave: {
                    showTableing: false
                },    
                form: {
                    add: true,
                    title: null,
                    show: false,
                },
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: [],
                    treeProps: {
                    children: 'children'
                    }
                },
                tableKbli: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: [],
                    treeProps: {
                    children: 'children'
                    }
                },
                errorMessage: null,   
                scopeofSupply: {},
                materialGroup: {},
                selectedSos: [],
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getMaterialGroup()
        },
        methods: {
            // get() {
            //     let context = this;

            //     Api(context, scopeofSupply.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {
            //         context.table.total = response.data.data.data.total;
            //         console.log('data', JSON.stringify(response.data.data.data.data));
            //         context.table.data = response.data.data.data.data;
            //         context.table.page  = response.data.data.data;
            //         context.onLoad.sos = false;
            //         context.onLoad.kbli = false;
            //     }).onError(function(error) {
            //         if (error.response.status == 404) {
            //             context.table.data = [];
            //             context.table.total = 0;
            //             context.onLoad.sos = false;
            //             context.onLoad.kbli = false;
            //         }
            //     }).call()
            // },
            get() {
                let context = this;

                Api(context, scopeofSupply.getInOneApi(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {
                    const resData = response.data.data.data;
                    context.table.total = resData.total;
                    context.table.data = resData.data;
                    context.table.page  = resData;
                    context.onLoad.sos = false;
                    context.onLoad.kbli = false;
                }).onError(function(error) {
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad.sos = false;
                        context.onLoad.kbli = false;
                    }
                }).call()
            },
            handleSosNodeClick(data, node) {
                if (data.level === 2 && Array.isArray(data.kbli)) {
                    this.copyToKbliTable(data.kbli);
                }
            },
            copyToKbliTable(children){
                let context = this;
                this.onLoad.kbli = true;
                if(Array.isArray(children) && children.length > 0){
                    context.tableKbli.data = children;
                    context.tableKbli.total = children.length;
                    context.tableKbli.page = [];
                    context.onLoad.kbli = false;
                } else {
                    context.tableKbli.data = [];
                    context.tableKbli.total = 0;
                    context.tableKbli.page = [];
                    context.onLoad.kbli = false;
                }
            },
            getMaterialGroup() {
                let context = this;

                Api(context, materialGroup.get({per_page: 'none'})).onSuccess(function(response) {
                    context.materialGroup = response.data.data.data.data;
                }).onError(function(error) {
                    if (error.response.status == 404) {
                        context.materialGroup = [];
                    }
                }).call()
            },
            filter() {
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.onLoad.sos = true;
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_scope_of_supply');
                this.form.show = true;
                this.scopeofSupply = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, scopeofSupply.show(id)).onSuccess(function(response) {
                    context.scopeofSupply = response.data.data
                    var material_group = [];
                    response.data.data.rel_sos_material_group.forEach(function(item) {
                        material_group.push(item.material_group_code)
                    })

                    context.scopeofSupply.material_group = material_group

                    context.form.add = false;
                    context.form.title = context.tt('edit_scope_of_supply');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                  
                this.btnSave.showTableing = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, scopeofSupply.create(this.scopeofSupply));
                } else {{
                    api = Api(context, scopeofSupply.update(this.scopeofSupply.id, this.scopeofSupply));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    if (!context.form.add) {
                        context.handleCurrentChange(context.currentRow)
                    }
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.showTableing = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, scopeofSupply.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChange(val) {
                let context = this; 
                context.currentRow = val     
                this.onLoad.kbli = true

                Api(context, scopeofSupply.relSosKbli(val.sos_header)).onSuccess(function(response) {
                    context.selectedSos = response.data.data.data.data
                }).onError(function(error) {                    
                    context.selectedSos = []
                }).onFinish(function() {
                    context.onLoad.kbli = false
                })
                .call()
            },
            rowClassName({ rowIndex }) {
                return 'table-success'
            },
            changePage(page) {
                let context = this;
                context.onLoad.sos = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()

                    context.selectedSos = []
                }, 100);
            }
        }   
    };
</script>
<style scoped>
    .sos-tree {
        font-size: 14px;
    }

    .border-radius-20>>>.el-input__inner {
        border-radius: 20px;
    }

    .sos-tree>>>.el-tree-node__content {
        height: auto;
        min-height: 45px;
        padding: 10px 0;
        border-bottom: 1px solid #e9ecef;
    }

    .sos-tree>>>.el-tree-node__content:hover {
        background-color: #f8f9fa;
    }

    .sos-tree >>> .el-tree-node.is-current > .el-tree-node__content {
    background-color: #fff3cd !important; /* kuning muda */
    color: #664d03;
    }
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        padding-right: 12px;
        gap: 8px;
    }

    .tree-node-left {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .tree-node-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .sos-header {
        font-weight: 700;
        color: #5e72e4;
        font-size: 15px;
        padding: 2px 8px;
        background: #f0f3ff;
        border-radius: 4px;
    }

    .sos-description {
        color: #32325d;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5;
        display: block;
        word-wrap: break-word;
    }

    .sos-definition {
        color: #8898aa;
        font-size: 12px;
        font-style: italic;
        line-height: 1.4;
        display: block;
        word-wrap: break-word;
    }

    .sos-tree>>>.el-tree-node__expand-icon {
        font-size: 14px;
        color: #525f7f;
        margin-right: 8px;
    }

    .sos-tree>>>.el-tree-node__expand-icon.is-leaf {
        color: transparent;
    }

    .sos-tree>>>.el-tree-node {
        white-space: normal;
    }

    .sos-tree>>>.el-tree-node__children {
        overflow: visible;
    }
</style>
    
